var rich_content_viewer_default = {
  "fontElementMap": "S5qqr",
  "wrapper": "td5E-",
  "pluginContainerMobile": "b-RrY",
  "viewer": "Y3MO7",
  "android": "Bw1OX",
  "rootedTraversedContent": "hM08C",
  "atomic": "ZAGNx",
  "toolbar": "RuoGL",
  "block": "j2jGK"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
